<template>
  <div class="container flex" style="margin-bottom: 30px;">
     <div>
       <left></left>
     </div>
     <div class="live feedback flex1" style="background-color: #fff;">
       <input type="file" multiple name="fileImage[]" class="el-upload__input" @change="getpic()" ref="file" style="display: none;" accept=".png,.jpg">
     	<div class="title">
     		意见反馈
     	</div>
     	<div class="" style="padding-left: 15px;">
     		<div class="" style="width: 100%;position: relative;">
     			<textarea rows="" cols="" placeholder="请输入您要反馈的问题（5-500字以内）" v-model="opinionContent"></textarea>
     		</div>
     		<div class="">
     			请提供问题的截图或照片（选填）
     		</div>
     		<div class="imglist flex">
     				<div class="imgwrap" v-for="item,index in opinionPicture">
     					<img :src="item" class="pic" >
     					<img src="../assets/img/delpic.png" class="delpic" @click="handleDelete(index)" >
     				</div>
     				<div class="imgwrap">
     					<img src="../assets/img/addpic.png" @click="uploadimg">
     				</div>
     		</div>
     		<div class="" style="margin: 15px 0;">
     			<span>联系方式（选填）</span>
     			<input type="tel" name="" id="" value="" placeholder="请输入手机号码" v-model="phone" />
     		</div>
     		<div class="btnwrap" style="cursor: pointer;">
     			<span class="btn" @click="handleSubmit">提交</span>
     		</div>
     	</div>
     </div>
  </div>
</template>

<script>
  import left from './accountleft.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          showLogin:false,
          opinionContent: '',
          phone:'',
          opinionPicture:[]
      }
    },
    watch:{
      opinionContent(val){
        if(val.length>0){

              this.opinionContent=val.slice(0,500)
        }
      }
    },
    methods:{
      handleOpenLogin(){
        this.$emit('handleOpenLogin')
      },
      handleDelete(index){
        this.opinionPicture.splice(index,1)
      },
      uploadimg:function(){

          document.querySelector('.el-upload__input').click();
      },
      getpic:function(){

              var el=document.querySelector('.el-upload__input');
              this.upload(el.files)
      //    console.log(URL.createObjectURL(el.files[0]))
      //    this.head=URL.createObjectURL(el.files[0]);
      },
      upload(files){
            for(let i=0;i<files.length;i++){
              let data=new FormData();
                  data.append('file',files[i]);
              this.$axios.post(this.$common.upload_url,data).then((res)=>{
                    if(res.data.status=='success'){
                         this.opinionPicture.push(res.data.message)
                    }
                    else {
                      alert(res.data.msg)
                    }
              })
            }
      },
      handleSubmit(){
          if(this.opinionContent.length<5){
            alert('反馈内容不能少于5个字')
            return;
          }
          let data=new FormData();
              data.append('opinionContent',this.opinionContent);
              data.append('phone',this.phone);
              data.append('opinionPicture',this.opinionPicture.join());
          this.$axios.post(this.$common.opinion_submit,data).then((res)=>{
                if(res.data.code==1){
                    this.opinionContent='';
                    this.phone='';
                    this.opinionPicture=[];
                    alert(res.data.msg)
                }
                else {
                  alert(res.data.msg)
                }
          })
      }
    }
  }
</script>

<style scoped="">
  input {
  	border: none;
    outline: none;
    line-height: 40px;
  }
  textarea {
  	border: none;
  	width: 80%;
    outline: none;
  }
  .pic {
  	width: 80px;
  	height: 80px;
  	object-fit: cover;
  }
  .imglist {
  	margin-top: 15px;
  }
  .imgwrap{
  	margin-right: 15px;
  	position: relative;
  }
  .delpic {
  	position: absolute;
  	right: 2px;
  	top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue